// import React from 'react';
// import Layout from '../components/layout';
// import { removeCookie } from '../config/webStorage';
// import { useUser } from '../config/userProvider';

// const Account = () => {

//   const { userData} = useUser();
//   // Simulated API Response


//   const logOutHandler = () => {
//     removeCookie("swpayrolltoken");
//     window.location.reload();
//   };

//   return (
//     <Layout>
//       <div className="flex items-center justify-center min-h-[80vh] bg-gray-50">
//         <div className="bg-white p-6 md:p-8 rounded-2xl shadow-2xl w-full max-w-2xl">
//           <h2 className="text-3xl font-bold text-center mb-6">My Account</h2>

//           <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
//             <div>
//               <strong>Name:</strong> {userData?.personalDetails?.firstName} {userData?.personalDetails?.lastName}
//             </div>
//             <div>
//               <strong>Email:</strong> {userData?.personalDetails?.email}
//               {/* <span className={`ml-2 inline-block text-xs px-2 py-0.5 rounded ${userData.verificationDetails.isEmailVerified ? 'bg-green-200 text-green-800' : 'bg-red-200 text-red-800'}`}>
//                 {userData.verificationDetails.isEmailVerified ? 'Verified' : 'Unverified'}
//               </span> */}
//             </div>
//             <div>
//               <strong>Phone:</strong> {userData?.personalDetails?.phone}
//               {/* <span className={`ml-2 inline-block text-xs px-2 py-0.5 rounded ${userData.verificationDetails.isPhoneVerified ? 'bg-green-200 text-green-800' : 'bg-red-200 text-red-800'}`}>
//                 {userData.verificationDetails.isPhoneVerified ? 'Verified' : 'Unverified'}
//               </span> */}
//             </div>
//             <div>
//               <strong>User ID:</strong> {userData?.id}
//             </div>
//             {/* <div>
//               <strong>User Type:</strong> {userData.userType}
//             </div> */}
//             <div>
//               <strong>Status:</strong> <span className={`px-2 py-0.5 rounded ${userData.employeeStatus === 'active' ? 'bg-green-200 text-green-800' : 'bg-red-200 text-red-800'}`}>{userData.employeeStatus}</span>
//             </div>
//             {/* <div>
//               <strong>Language:</strong> {userData.preferences.language}
//             </div>
//             <div>
//               <strong>Theme:</strong> {userData.preferences.theme}
//             </div> */}
//             {/* <div className="col-span-2">
//               <strong>Notifications:</strong>
//               <ul className="list-disc list-inside ml-4">
//                 {Object.entries(userData.preferences.notifications).map(([type, value]) => (
//                   <li key={type}>{type.toUpperCase()}: {value ? 'Enabled ✅' : 'Disabled ❌'}</li>
//                 ))}
//               </ul>
//             </div> */}
//             <div>
//               <strong>Joined:</strong> {new Date(userData.employeeJoiningDate).toLocaleDateString()}
//             </div>
//             <div>
//               <strong>Last Updated:</strong> {new Date(userData.updatedAt).toLocaleDateString()}
//             </div>
//           </div>

//           <div className="mt-8 flex justify-center">
//             <button 
//               onClick={logOutHandler} 
//               className="bg-red-500 hover:bg-red-600 text-white px-6 py-2 rounded-xl"
//             >
//               Logout
//             </button>
//           </div>
//         </div>
//       </div>
//     </Layout>
//   );
// };

// export default Account;

import React from 'react';
import Layout, { Container } from '../components/layout';
import { removeCookie } from '../config/webStorage';
import { useUser } from '../config/userProvider';

const formatBoolean = (val) => val ? 'Yes ✅' : 'No ❌';
const formatDate = (date) => date ? new Date(date).toLocaleDateString() : '—';

const Section = ({ title, children }) => (
  <div className="mb-6">
    <h3 className="text-xl font-semibold mb-2 text-gray-700">{title}</h3>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm bg-gray-50 p-4 rounded-lg shadow-sm">
      {children}
    </div>
  </div>
);

const Account = () => {
  const { userData } = useUser();

  const logOutHandler = () => {
    removeCookie("SWFMSToken");
    window.location.reload();
  };

  return (
    <Layout>
    <Container overflow={"overflow-scroll"}>
      <div className="flex items-start justify-center  bg-gray-100 p-5">
        <div className="bg-white p-6  rounded-2xl w-full ">
        <div className="flex justify-between items-center bg-gray-50 p-4 rounded-lg shadow-sm mb-10">
        <h2 className="text-3xl font-bold text-center">My Account</h2>
            <button
              onClick={logOutHandler}
              className="bg-red-600 hover:bg-red-700 text-white px-6 py-2 rounded-xl"
            >
              Logout
            </button>
          </div>

          {/* Section: Personal Details */}
          <Section title="Personal Details">
            <div><strong>Name:</strong> {userData.personalDetails?.firstName} {userData.personalDetails?.lastName}</div>
            <div><strong>Email:</strong> {userData.personalDetails?.email}</div>
            <div><strong>Phone:</strong> {userData.personalDetails?.phone}</div>
            <div><strong>DOB:</strong> {formatDate(userData.personalDetails?.dateOfBirth)}</div>
            <div><strong>Gender:</strong> {userData.personalDetails?.gender}</div>
            <div><strong>Marital Status:</strong> {userData.personalDetails?.maritalStatus}</div>
            <div><strong>Religion:</strong> {userData.personalDetails?.religion}</div>
            <div><strong>Nationality:</strong> {userData.personalDetails?.nationality}</div>
            <div><strong>Disability:</strong> {formatBoolean(userData.personalDetails?.disabilityStatus)}</div>
            <div><strong>Blood Group:</strong> {userData.personalDetails?.bloodGroup}</div>
            <div><strong>Permanent Address:</strong> {userData.personalDetails?.permanentAddress?.address1}</div>
            <div><strong>Current Address:</strong> {userData.personalDetails?.currentAddress?.address1 || '—'}</div>
          </Section>

          {/* Section: Bank Details */}
          <Section title="Bank Details">
            <div><strong>Account Holder:</strong> {userData.bankDetails?.accountHolderName}</div>
            <div><strong>Account Number:</strong> {userData.bankDetails?.accountNumber}</div>
            <div><strong>IFSC:</strong> {userData.bankDetails?.ifscCode}</div>
            <div><strong>Account Type:</strong> {userData.bankDetails?.accountType}</div>
          </Section>

          {/* Section: Identification */}
          <Section title="Identification">
            <div><strong>Aadhar:</strong> {userData.identification?.aadharNumber}</div>
            <div><strong>PAN:</strong> {userData.identification?.panNumber}</div>
            <div><strong>UAN:</strong> {userData.identification?.uanNumber || '—'}</div>
          </Section>

          {/* Section: Emergency Contact */}
          <Section title="Emergency Contact">
            <div><strong>Name:</strong> {userData.emergencyContactDetails?.emergencyContactName}</div>
            <div><strong>Relationship:</strong> {userData.emergencyContactDetails?.emergencyContactRelationship}</div>
            <div><strong>Phone:</strong> {userData.emergencyContactDetails?.emergencyContactPhone}</div>
          </Section>

          {/* Section: Employment Details */}
          <Section title="Employment">
            <div><strong>Employee Code:</strong> {userData.employeeCode}</div>
            <div><strong>Status:</strong> {userData.employeeStatus}</div>
            <div><strong>Type:</strong> {userData.employeeType}</div>
            <div><strong>Department:</strong> {userData.department}</div>
            <div><strong>Designation:</strong> {userData.designation}</div>
            <div><strong>Location:</strong> {userData.officeLocation}</div>
            <div><strong>Joining Date:</strong> {formatDate(userData.employeeJoiningDate)}</div>
            <div><strong>Manager:</strong> {userData.reportingManagerName}</div>
          </Section>

          {/* Section: Leave Details */}
          <Section title="Leave Balance">
            {Object.entries(userData.leaveBalance || {}).map(([key, val]) =>
              typeof val === 'number' && (
                <div key={key}>
                  <strong>{key.replace(/([A-Z])/g, ' $1')}:</strong> {val}
                </div>
              )
            )}
          </Section>

          {/* Section: Statutory */}
          <Section title="Statutory Compliance">
            <div><strong>PF Eligible:</strong> {formatBoolean(userData.statutoryCompliances?.pfEligible)}</div>
            <div><strong>ESI Eligible:</strong> {formatBoolean(userData.statutoryCompliances?.esiEligible)}</div>
            <div><strong>Gratuity Eligible:</strong> {formatBoolean(userData.statutoryCompliances?.gratuityEligible)}</div>
            <div><strong>Bonus Eligible:</strong> {formatBoolean(userData.statutoryCompliances?.bonusEligible)}</div>
            <div><strong>LWF Eligible:</strong> {formatBoolean(userData.statutoryCompliances?.lwfEligible)}</div>
          </Section>

          {/* Section: Offer Details */}
          <Section title="Offer & Salary">
            <div><strong>Offered CTC:</strong> ₹{userData.offerDetails?.salaryDetails?.offeredCTC}</div>
            <div><strong>Monthly Salary:</strong> ₹{userData.offerDetails?.salaryDetails?.monthlySalary}</div>
            <div><strong>Currency:</strong> {userData.offerDetails?.salaryDetails?.currency}</div>
            <div><strong>Salary Mode:</strong> {userData.offerDetails?.salaryDetails?.salaryMode}</div>
            <div><strong>Onboarding Completed:</strong> {formatBoolean(userData.offerDetails?.onboardingCompleted)}</div>
            <div><strong>Offer Status:</strong> {userData.offerDetails?.offerLetterStatus}</div>
          </Section>

          {/* Section: Documents */}
          <Section title="Documents Status">
            {Object.entries(userData.documents || {}).filter(([key]) => typeof userData.documents[key] === 'object' && key !== 'verificationStatus' && key !== 'verificationRemarks').map(([docKey, doc]) => (
              <div key={docKey}>
                <strong>{docKey.replace(/([A-Z])/g, ' $1')}:</strong> {doc?.uploaded ? 'Uploaded ✅' : 'Not Uploaded ❌'}
              </div>
            ))}
          </Section>
        </div>
      </div>
    </Container>
    </Layout>
  );
};

export default Account;
